module.exports = __webpack_public_path__ + "img/michael.0878238d.jpg";